import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Department, DepartmentCreate, DepartmentFilter } from '../data/department';

export function createDepartmentService(client: AxiosInstance) {
  return createCrudService<Department, DepartmentCreate, DepartmentFilter>(
    client,
    '/master-data/Department',
    'departmentId',
  );
}

export type DepartmentService = CrudService<Department, DepartmentCreate, DepartmentFilter>;
